import placesCategoryService from "../../services/placesCategoryService";
import {
    PLACES_CATEGORY_GET_REQUEST,
    PLACES_CATEGORY_GET_SUCCESS,
    PLACES_CATEGORY_GET_FAILURE,
    PLACES_CATEGORY_ADD_REQUEST,
    PLACES_CATEGORY_ADD_SUCCESS,
    PLACES_CATEGORY_ADD_FAILURE,
    PLACES_CATEGORY_DELETE_REQUEST,
    PLACES_CATEGORY_DELETE_SUCCESS,
    PLACES_CATEGORY_DELETE_FAILURE,
} from "./actionTypes";

// Places Category Get Action
export const fetchPlacesCategory = (queryModel) => {
    return async (dispatch) => {
        dispatch({ type: PLACES_CATEGORY_GET_REQUEST }); // İstek başlatıldı
        try {
            const response = await placesCategoryService.fetchPlaceCategories(queryModel); // Servis çağrısı
            const { data } = response;
            dispatch({ type: PLACES_CATEGORY_GET_SUCCESS, payload: data }); // Başarılı sonuç
            return data;
        } catch (error) {
            dispatch({
                type: PLACES_CATEGORY_GET_FAILURE,
                payload: error.message, // Hata mesajını taşı
            });
            return Promise.reject(error); // Hata durumunda reddet
        }
    };
};

// Places Category Add Action
export const addPlacesCategory = (categoryData, token) => {
    return async (dispatch) => {
        dispatch({ type: PLACES_CATEGORY_ADD_REQUEST });
        try {
            const response = await placesCategoryService.addPlacesCategory(categoryData, token);
            const { data } = response;
            dispatch({ type: PLACES_CATEGORY_ADD_SUCCESS, payload: data });
            return data;
        } catch (error) {
            dispatch({ type: PLACES_CATEGORY_ADD_FAILURE, payload: error.message });
            return Promise.reject(error);
        }
    };
};

// Places Category Delete Action
export const deletePlacesCategory = (id, token) => {
    return async (dispatch) => {
        dispatch({ type: PLACES_CATEGORY_DELETE_REQUEST }); // İstek başlatıldı
        try {
            await placesCategoryService.deletePlacesCategory(id, token); // Servis çağrısı

            dispatch({ type: PLACES_CATEGORY_DELETE_SUCCESS, payload: id }); // Başarılı sonuç
        } catch (error) {
            dispatch({
                type: PLACES_CATEGORY_DELETE_FAILURE,
                payload: error.message, // Hata mesajını taşı
            });
            return Promise.reject(error); // Hata durumunda reddet
        }
    };
};
